var React = require('react');

function Blob (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FF0066","d":"M35,-40.1C44.1,-26,49.2,-13,53.7,4.5C58.1,21.9,62,43.9,52.9,57.2C43.9,70.5,21.9,75.2,1.9,73.2C-18.1,71.3,-36.2,62.8,-50.4,49.5C-64.6,36.2,-74.9,18.1,-72.8,2.1C-70.7,-13.8,-56,-27.6,-41.8,-41.8C-27.6,-56,-13.8,-70.5,-0.4,-70.1C13,-69.7,26,-54.3,35,-40.1Z","transform":"translate(100 100)"}));
}

Blob.defaultProps = {"viewBox":"0 0 200 200"};

module.exports = Blob;

Blob.default = Blob;
